module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"requiredInput":"Required input"},"ja":{"requiredInput":"必須入力"},"zh-hant":{"requiredInput":"必需的輸入"},"zh-hans":{"requiredInput":"必需的输入"}}')
  delete Component.options._Ctor
}
